const initialState = {
  stations: [],
};

export const setStations = (state, { payload }) => ({
  ...state,
  stations: payload,
});

export const clearStations = () => initialState;

export default initialState;
